<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout column>
      <v-flex xs12 style="position: relative; flex-basis: auto">
        <v-text-field
          placeholder="Cautare"
          hint="Se cauta dupa id_scara, adresa, observatii scara"
          clearable
          persistent-hint
          append-icon="mdi-magnify"
          solo
          :loading="loading"
          single-line
          @click:append="_cbSearch"
          @keydown.enter="_cbSearch"
          :suffix="String(total)"
          v-model="searchTerm">
        </v-text-field>
      </v-flex>
      <v-flex xs12>
        <split-pane :min-percent="10" :default-percent="paneHorizontal" split="vertical" @resize="paneResize($event, 'horizontal')">
          <template slot="paneL">
            <v-card style="display: flex; flex-direction: column; height: 100%">
              <v-card-title>
                <div style="display: flex; flex-direction: column; flex-grow: 1">
                  <div style="display: flex; flex-grow: 1; align-items: center; justify-content: space-between">

                    <span key="title" style="flex-grow: 1">Simboluri</span>

                    <v-avatar size="18" class="ma-1" @click="_cbAddEntity" key="add-entity" title="Adauga simbol">
                      <v-icon :size="20" :color="light ? 'primary' : 'primary lighten-2'">
                        mdi-plus-circle
                      </v-icon>
                    </v-avatar>

                    <v-divider vertical class="mr-2"></v-divider>

                    <div key="toolbar" style="flex-grow: 1">
                      <v-avatar size="18" class="ma-1" @click="toggleDone" key="toggle-done" :title="done === null ? 'Done si Not Done' : (done === 1 ? 'Done' : 'Not Done')">
                        <v-icon :color="doneColor" :size="20">
                          {{done === null ? 'mdi-check-circle-outline' : (done === 1 ? 'mdi-check-circle' : 'mdi-close-circle')}}
                        </v-icon>
                      </v-avatar>

                      <v-avatar size="18" class="ma-1" @click="toggleEdited" key="toggle-edited" :title="edited === null ? 'Editate si Needitate' : (edited === 1 ? 'Editate' : 'Needitate')">
                        <v-icon :color="editedColor" :size="20">
                          {{edited === null ? 'mdi-pencil-outline' : (edited === 1 ? 'mdi-pencil' : 'mdi-pencil-off')}}
                        </v-icon>
                      </v-avatar>

                      <v-avatar size="18" class="ma-1" @click="togglePhotos" key="toggle-photos" :title="photos === null ? 'Cu si Fara Poze' : (photos === 1 ? 'Cu Poze' : 'Fara Poze')">
                        <v-icon :color="photosColor" :size="20">
                          {{photos === null ? 'mdi-camera-outline' : (photos === 1 ? 'mdi-camera' : 'mdi-camera-off')}}
                        </v-icon>
                      </v-avatar>

                      <v-avatar size="18" class="mx-1" @click="toggleRepozare" key="toggle-repozare" :title="repozare === null ? 'Cu si Fara Repozare' : (repozare === 1 ? 'Cu Repozare' : 'Fara Repozare')">
                        <v-icon :color="repozareColor" :size="20">
                          {{repozare === null ? 'mdi-alpha-r-circle-outline' : 'mdi-alpha-r-circle'}}
                        </v-icon>
                      </v-avatar>

                      <v-avatar size="18" class="mx-1" @click="toggleExcels" key="toggle-excels" :title="excels === null ? 'Cu si Fara Excel-uri' : (excels === 1 ? 'Cu Excel-uri' : 'Fara Excel-uri')">
                        <v-icon :color="excelsColor" :size="20">
                          {{excels === null ? 'mdi-file-excel-outline' : (excels === 1 ? 'mdi-file-excel' : 'mdi-file-excel')}}
                        </v-icon>
                      </v-avatar>

                      <!-- <v-avatar size="18" class="ma-1" @click="toggle2005" key="toggle-2005" :title="_2005 === null ? 'Fara bifa constructie dupa 2005' : (_2005 === 1 ? 'Constructie dupa 2005' : 'Constructie inainte de 2005')">
                        <v-icon :color="_2005Color" :size="20">
                          {{_2005 === null ? 'mdi-calendar-minus' : (_2005 === 1 ? 'mdi-calendar-arrow-right' : 'mdi-calendar-arrow-left')}}
                        </v-icon>
                      </v-avatar> -->

                      <!-- <v-avatar size="18" class="ma-1" @click="togglePdfs" key="toggle-pdfs" :title="pdfs === null ? 'Cu si Fara Pdf-uri' : (pdfs === 1 ? 'Cu Pdf-uri' : 'Fara Pdf-uri')">
                        <v-icon :color="pdfsColor" :size="20">
                          {{pdfs === null ? 'mdi-file-pdf-outline' : (pdfs === 1 ? 'mdi-file-pdf' : 'mdi-file-pdf')}}
                        </v-icon>
                      </v-avatar> -->
                    </div>

                    <!-- <v-divider vertical dark key="div-3"></v-divider> -->

                    <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap;" key="deleteSimbols">
                      <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeleteSymbolsBatch" v-if="deleteSymbolsEnabled" key="confirmBatch" title="Sterge simbolurile de pe pagina, conform filtrelor">
                        <v-icon :size="20" color="error">mdi-bomb</v-icon>
                      </v-btn>
                      <span v-if="deleteSymbolsEnabled" key="todeletelenbatch">
                        {{items.length}}
                      </span>

                      <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeleteSymbols" v-if="deleteSymbolsEnabled && toDeleteSymbols.length" key="confirm" title="Sterge simbolurile selectate">
                        <v-icon :size="20" color="error">mdi-check-circle</v-icon>
                      </v-btn>
                      <span v-if="deleteSymbolsEnabled && toDeleteSymbols.length" key="todeletelen">
                        {{toDeleteSymbols.length}}
                      </span>
                      <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode('symbol')" key="delete" :title="deleteSymbolsEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'">
                        <v-icon :size="20" :color="deleteSymbolsEnabled ? 'error' : (light ? 'blue-grey' : 'grey lighten-2')">mdi-delete-circle</v-icon>
                      </v-btn>
                    </div>

                    <!-- <v-divider vertical dark key="div-1"></v-divider> -->

                    <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap" key="download">
                      <v-btn class="ma-0" icon @click="uplaodXLSX" :color="light ? 'primary' : 'primary lighten-2'" flat key="xlsx-up" title="Upload simboluri din xlsx">
                        <v-icon :size="20">mdi-file-upload</v-icon>
                      </v-btn>

                      <v-divider vertical></v-divider>
                      <!-- <v-divider vertical dark key="div-2"></v-divider> -->
                      <v-btn class="ma-0" icon @click="downloadXLSX(false)" :color="light ? 'primary' : 'primary lighten-2'" flat key="xlsx-down" :loading="downloading" :disabled="downloading" title="Descarca xlsx cu TOATE simbolurile (tinand cont de eticheta, zona si user)">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-btn class="ma-0" icon @click="downloadXLSX(true)" color="accent" flat key="xlsx-down-f" :loading="downloading" :disabled="downloading" :title="`Descarca xlsx DOAR cu simbolurile afisate (${items.length} simboluri)`">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-btn class="ma-0" icon @click="downloadRaport2" color="blue" flat key="xlsx-down-rap2" :loading="downloading" :disabled="downloading" :title="`Descarca xlsx pt verificare autor poze`">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-btn class="ma-0" icon @click="downloadRaportDuplicat" color="yellow" flat key="xlsx-down-rap3" :loading="downloading" :disabled="downloading" :title="`Descarca xlsx cu poze duplicat (tinand cont de filtre). DO NOT FEED IT TOO MAHY THINGS AT ONCE! You have been warned.`">
                        <v-icon :size="20">mdi-file-download</v-icon>
                      </v-btn>
                      <v-divider vertical></v-divider>
                      <v-btn v-if="tab === 'photos'" class="ma-0" icon flat @click="download('symbols')" key="downloadbtn" :title="`Descarca pozele simbolurilor afisate (grupate pe foldere) - ${items.length} simboluri`">
                        <v-icon :size="20" color="accent">mdi-package-down</v-icon>
                      </v-btn>
                      <!-- <v-btn v-if="tab === 'pdfs'" class="ma-0" icon flat @click="downloadPdfs('grouped')" key="downloadpdfsbtn" :title="`Descarca pdf-urile simbolurilor afisate (grupate pe foldere) - ${items.length} simboluri`">
                        <v-icon :size="20" color="accent">mdi-package-down</v-icon>
                      </v-btn> -->
                      <v-btn v-if="tab === 'excels'" class="ma-0" icon flat @click="downloadExcels('grouped')" key="downloadexcelsbtn" :title="`Descarca excel-urile simbolurilor afisate (grupate pe foldere) - ${items.length} simboluri`">
                        <v-icon :size="20" color="accent">mdi-package-down</v-icon>
                      </v-btn>
                      <span key="downaloadocunt">{{selectedItems.length || items.length}}</span>

                      <v-divider vertical class="ml-2"></v-divider>

                      <v-btn icon flat class="ma-0" :title="showGallery ? 'Ascunde panoul de fisiere' : 'Arata panoul de fisiere'" @click="toggleGallery">
                        <v-icon :size="16">{{ showGallery ? 'mdi-arrow-collapse-right' : 'mdi-arrow-collapse-left' }}</v-icon>
                      </v-btn>
                    </div>

                  </div>

                  <v-layout row>
                    <v-flex>
                      Eticheta:
                      <v-chip color="grey lighten-2" text-color="primary" @click="openLabelsDialog" close @input="resetLabel" small>
                        <v-icon :size="14">mdi-filter</v-icon>
                        {{ selectedLabel === null ? 'Toate' : (selectedLabel === undefined ? 'Undefined' : selectedLabel) }}
                      </v-chip>
                    </v-flex>
                    <v-flex>
                      Zona:
                      <v-chip color="grey lighten-2" text-color="primary" @click="openZonesDialog" close @input="resetZona" small>
                        <v-icon :size="14">mdi-filter</v-icon>
                        {{ selectedZona === null ? 'Toate' : (selectedZona === undefined ? 'Undefined' : selectedZona) }}
                      </v-chip>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex>
                      Data inceput

                      <v-menu
                        v-model="data_inceput_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        :transition="false"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-chip color="grey lighten-2" text-color="primary" v-on="on" @input="resetData('Inceput')" close small>
                            <v-icon :size="14">mdi-filter</v-icon>
                            {{ dataInceput | dateFormat }}
                          </v-chip>
                        </template>
                        <v-date-picker v-model="dataInceput" @input="data_inceput_menu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex>
                      Data sfarsit

                      <v-menu
                        v-model="data_sfarsit_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        :transition="false"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-chip color="grey lighten-2" text-color="primary" v-on="on" @input="resetData('Sfarsit')" close small>
                            <v-icon :size="14">mdi-filter</v-icon>
                            {{ dataSfarsit | dateFormat }}
                          </v-chip>
                        </template>
                        <v-date-picker v-model="dataSfarsit" @input="data_sfarsit_menu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex class="pr-2">
                      <v-text-field
                        v-model.number="perPage"
                        hide-details
                        type="number"
                        min="1"
                        :color="light ? 'primary' : 'primary lighten-2'"
                        flat
                        label="Simboluri pe pagina">
                      </v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-select
                        v-model="selectedUsernames"
                        :items="users"
                        :menu-props="{ maxHeight: '400' }"
                        label="Filtru utilizator(i) (ultima persoana care a intervenit pe detaliile entitatii)"
                        multiple
                        :color="light ? 'primary' : 'primary lighten-2'"
                        append-outer-icon="mdi-magnify" @click:append-outer="filterByUsername">
                      </v-select>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-title>
              <v-card-text style="flex-grow: 1; display: flex; flex-wrap: wrap; overflow-y: auto" class="pa-0">
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; flex-grow: 1; align-content: flex-start">
                  <template v-for="item in items">
                    <div :key="item._id" style="display: flex; flex-direction: column; align-items: center; flex-grow: 0;">
                      <v-avatar
                        style="cursor: pointer"
                        size="48"
                        class="ma-2 symbol"
                        :class="{
                          'selected-symbol': isSelectedItem(item),
                          'delete-enabled': deleteSymbolsEnabled,
                          'toDelete opacity1': toDeleteSymbols.includes(item._id),
                          'opacity1': !deleteSymbolsEnabled && isSelectedItem(item)
                        }"
                        tile
                        @click="_cbSelectDeleteSymbolProxy(item)">
                        <v-img :src="getSrc(item)">
                        </v-img>
                      </v-avatar>
                      <span
                        :key="item._id"
                        class="caption px-1"
                        style="text-align: center"
                        :class="{
                          'blue-grey--text': light && !deleteSymbolsEnabled,
                          'grey--text text--lighten-2': !light && !deleteSymbolsEnabled,
                          'primary--text font-weight-bold opacity1': !deleteSymbolsEnabled && selectedItems.length && isSelectedItem(item),
                          'error--text': deleteSymbolsEnabled,
                          'font-weight-bold opacity1': toDeleteSymbols.includes(item._id)
                        }">
                        {{item.id_scara}}
                        (
                          {{item.photos.length}}
                          <v-icon :size="12" :color="light ? 'blue-grey' : 'grey lighten-2'">mdi-camera</v-icon>
                          <!-- &amp;
                          {{item.pdfs.length}}
                          <v-icon :size="12" :color="light ? 'blue-grey' : 'grey lighten-2'">mdi-file-pdf</v-icon> -->
                          &amp;
                          {{item.excels.length}}
                          <v-icon :size="12" :color="light ? 'blue-grey' : 'grey lighten-2'">mdi-file-excel</v-icon>
                        )
                        <br>
                        <v-icon :size="12" :color="light ? 'blue-grey' : 'grey lighten-2'">mdi-update</v-icon>
                        {{item.updatedAt | dateFormat}}
                        <br>
                        <v-icon :size="12" :color="light ? 'blue-grey' : 'grey lighten-2'">mdi-account</v-icon>
                        {{ item.user || 'neatins'}}
                      </span>
                    </div>
                  </template>
                </div>
              </v-card-text>
              <v-card-actions style="text-align: center; overflow-x: auto; flex: 0 0 64px" class="pa-0">
                <v-spacer></v-spacer>
                <v-pagination
                  style="justify-content: center"
                  v-model="page"
                  :length="totalPages"
                  :total-visible="5"
                  circle
                ></v-pagination>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </template>
          <template slot="paneR" v-if="showGallery">
            <split-pane :min-percent="10" :default-percent="paneVertical" split="horizontal" @resize="paneResize($event, 'vertical')">
              <template slot="paneL">
                <v-card style="display: flex; flex-direction: column; height: 100%">
                  <v-card-title style="flex-direction: column; align-items: stretch; ">
                    <div style="height: 28px; display: flex; align-items: center; flex-grow: 1">
                      <v-btn icon flat class="ma-0" :title="showPreview ? 'Ascunde panoul de preview' : 'Arata panoul de preview'" @click="togglePreview">
                        <v-icon :size="16">{{ showPreview ? 'mdi-arrow-collapse-down' : 'mdi-arrow-collapse-up' }}</v-icon>
                      </v-btn>

                      <v-divider vertical class="mr-2"></v-divider>

                      <span>Galerie ({{selectedItems.length || items.length}} simboluri {{ selectedItems.length ? ' selectate' : 'pe pagina' }})</span>

                      <!-- <v-scale-transition appear> -->
                        <v-btn icon small v-if="selectedItems.length" class="ma-0 ml-1" title="Deselecteaza toate simbolurile" @click="clearSelected">
                          <v-icon small color="error">mdi-close</v-icon>
                        </v-btn>
                      <!-- </v-scale-transition> -->
                      <v-spacer></v-spacer>

                      <v-btn small icon @click="toggleTab">
                        <v-icon small :color="tab === 'photos' ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-camera</v-icon>
                      </v-btn>
                      <!-- <v-btn small icon @click="toggleTab">
                        <v-icon small :color="tab === 'pdfs' ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-file-pdf</v-icon>
                      </v-btn> -->
                      <v-btn small icon @click="toggleTab">
                        <v-icon small :color="tab === 'excels' ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-file-excel</v-icon>
                      </v-btn>

                      <v-spacer></v-spacer>
                      <v-menu offset-y :close-on-content-click="false" v-if="tab === 'photos'">
                        <template v-slot:activator="{ on }">
                          <v-btn small icon v-on="on" title="Selecteaza tipul de poze vizibile">
                            <v-icon small :color="light ? 'primary' : 'primary lighten-2'">mdi-camera-burst</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <v-list-tile v-for="tip in availableTipPoze" :key="tip">
                            <v-list-tile-action>
                              <v-switch v-model="tipPoze" :value="tip"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ tip }}</v-list-tile-title>
                          </v-list-tile>

                          <v-list-tile>
                            <v-list-tile-action>
                              <v-switch v-model="tipPoze" value="bad photos"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>
                              Bad photos only!
                              <v-icon color="warning" small>mdi-alert</v-icon>
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                      <v-menu offset-y :close-on-content-click="false" v-if="tab === 'excels'">
                        <template v-slot:activator="{ on }">
                          <v-btn small icon v-on="on" title="Selecteaza tipul de exceluri vizibile">
                            <v-icon small :color="light ? 'primary' : 'primary lighten-2'">mdi-microsoft-excel</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <v-list-tile v-for="tip in availableTipExcels" :key="tip">
                            <v-list-tile-action>
                              <v-switch v-model="tipExcels" :value="tip"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ tip }}</v-list-tile-title>
                          </v-list-tile>

                          <v-list-tile>
                            <v-list-tile-action>
                              <v-switch v-model="tipExcels" value="bad excels"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>
                              Bad excels only!
                              <v-icon color="warning" small>mdi-alert</v-icon>
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                      <v-spacer></v-spacer>

                      <!-- <v-scale-transition appear group> -->
                        <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-if="deleteEnabled && toDelete.length" key="confirm" title="Sterge pozele selectate">
                          <v-icon color="error">mdi-check-circle</v-icon>
                        </v-btn>
                        <span v-show="deleteEnabled && toDelete.length" key="todeletelen">
                          {{toDelete.length}}
                        </span>
                        <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode('photo')" key="delete" :title="deleteEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'">
                          <v-icon :color="deleteEnabled ? 'error' : (light ? 'blue-grey' : 'grey lighten-2')">mdi-delete-circle</v-icon>
                        </v-btn>
                      <!-- </v-scale-transition> -->
                      <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap;" key="download">
                        <v-btn v-if="tab === 'photos'" class="ma-0" icon flat @click="download('photos')" key="downloadbtn" :disabled="!visiblePhotosCount" :title="`Descarca pozele afisate (fara grupare pe foldere) - ${items.length} simboluri`">
                          <v-icon color="accent">mdi-package-down</v-icon>
                          <span>{{visiblePhotosCount}}</span>
                        </v-btn>
                        <!-- <v-btn v-if="tab === 'pdfs'" class="ma-0" icon flat @click="downloadPdfs('simple')" key="downloadpdfsbtn" :disabled="!visiblePdfsCount" :title="`Descarca pdf-urile afisate (fara grupare pe foldere) - ${items.length} simboluri`">
                          <v-icon color="accent">mdi-package-down</v-icon>
                          <span>{{visiblePdfsCount}}</span>
                        </v-btn> -->
                        <v-btn v-if="tab === 'excels'" class="ma-0" icon flat @click="downloadExcels('simple')" key="downloadexcelsbtn" :disabled="!visibleExcelsCount" :title="`Descarca excel-urile afisate (fara grupare pe foldere) - ${items.length} simboluri`">
                          <v-icon color="accent">mdi-package-down</v-icon>
                          <span>{{visibleExcelsCount}}</span>
                        </v-btn>
                      </div>
                    </div>
                    <v-progress-linear height="18" color="accent" class="my-0 mt-2" :value="info.usedPercentage" v-if="info.freeGb" style="text-align: center">
                       <div class="pl-2 white--text" style="display: flex; align-items: center; justify-content: space-around; height: 100%">
                        <v-icon small color="white" >mdi-server-network</v-icon>
                        {{ info.freeGb }}GB liberi din {{ info.totalGb }}GB
                        <span>
                          (
                          <v-icon small color="white" >mdi-image</v-icon>
                          {{ info.photos }}B
                          <v-icon small color="white" >mdi-file-excel</v-icon>
                          {{ info.excels }}B
                          )
                        </span>
                        <v-icon small color="white" @click="refreshInfo">mdi-refresh</v-icon>
                       </div>
                    </v-progress-linear>
                  </v-card-title>
                  <v-card-text style="display: flex; flex-wrap: wrap; overflow-y: auto" class="pa-0">
                    <template v-if="tab === 'photos'">
                      <template v-if="selectedItems.length">
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in selectedItems">
                            <template v-for="(photo, index) in item.photos">
                              <div
                                v-if="((tipPoze.includes(photo.split('_')[1]) || tipPoze.includes(photo.split('_')[4])) || tipPoze.includes(photo.split('_')[4])) && showIfBadPhoto(photo)"
                                :key="item._id + 'photo' + index"
                                class="ma-1 photo-div"
                                style="display: flex; flex-direction: column; align-items: center; width: 64px"
                                @click="_cbSelectDeletePhotoProxy(item._id, photo)">
                                <img
                                  style="flex-grow: 0"
                                  :key="item._id + '_' + index"
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  loading="lazy"
                                  class="pa-1 ma-1 photo"
                                  :class="{
                                    'selected-photo': selectedPhoto && selectedPhoto.photo === photo,
                                    'toDelete': isToDelete(photo),
                                    'delete-enabled': deleteEnabled
                                  }">
                                    <!-- <template v-slot:placeholder>
                                      <v-layout
                                        fill-height
                                        align-center
                                        justify-center
                                        ma-0>
                                        <v-progress-circular indeterminate :color="light ? 'primary' : 'primary lighten-2'"></v-progress-circular>
                                      </v-layout>
                                    </template> -->
                                <!-- </img> -->
                                <div
                                  class="filename-truncation"
                                  :key="item._id + '_' + index + 'simbol'"
                                  :class="{
                                    'blue-grey--text': light && !deleteEnabled,
                                    'grey--text text--lighten-2': !light && !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedPhoto && selectedPhoto.photo === photo,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(photo)
                                  }">
                                  {{item.id_scara}}_{{photo.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                </div>
                                <div
                                  class="filename-truncation font-weight-bold"
                                  :key="item._id + '_' + index + 'user'"
                                  :class="{
                                    'blue-grey--text': light && !deleteEnabled,
                                    'grey--text text--lighten-2': !light && !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedPhoto && selectedPhoto.photo === photo,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(photo)
                                  }">
                                  {{usersDict[photo.split('_')[2]] || 'Anonim'}}
                                </div>
                                <div>
                                  <v-icon small color="warning" v-if="photo.includes('_badphoto')" title="Poza marcata de user ca fiind necorespunzatoare">mdi-alert</v-icon>
                                  <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                                  <a :href="serverURL + photo" download target="_blank" style="text-decoration: none" title="Descarca poza">
                                    <v-icon small :color="selectedPhoto && selectedPhoto.photo === photo ?  (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-download</v-icon>
                                  </a>
                                </div>
                              </div>
                            </template>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in items">
                            <template v-for="(photo, index) in item.photos">
                              <div
                                v-if="(tipPoze.includes(photo.split('_')[1]) || tipPoze.includes(photo.split('_')[4])) && showIfBadPhoto(photo)"
                                :key="item._id + 'photo' + index"
                                class="ma-1 photo-div"
                                style="display: flex; flex-direction: column; align-items: center; width: 64px"
                                @click="_cbSelectDeletePhotoProxy(item._id, photo)"
                                >
                                <img
                                  style="flex-grow: 0"
                                  :key="item._id + '_' + index"
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  loading="lazy"
                                  class="pa-1 ma-1 photo"
                                  :class="{
                                    'selected-photo': selectedPhoto && selectedPhoto.photo === photo,
                                    'toDelete': isToDelete(photo),
                                    'delete-enabled': deleteEnabled
                                  }">
                                    <!-- <template v-slot:placeholder>
                                      <v-layout
                                        fill-height
                                        align-center
                                        justify-center
                                        ma-0>
                                        <v-progress-circular indeterminate :color="light ? 'primary' : 'primary lighten-2'"></v-progress-circular>
                                      </v-layout>
                                    </template> -->
                                <!-- </img> -->
                                <div
                                  class="filename-truncation"
                                  :key="item._id + '_' + index + 'simbol'"
                                  :class="{
                                    'blue-grey--text': light && !deleteEnabled,
                                    'grey--text text--lighten-2': !light && !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedPhoto && selectedPhoto.photo === photo,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(photo)
                                  }">
                                  {{item.id_scara}}_{{photo.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                </div>
                                <div
                                  class="filename-truncation font-weight-bold"
                                  :key="item._id + '_' + index + 'user'"
                                  :class="{
                                    'blue-grey--text': light && !deleteEnabled,
                                    'grey--text text--lighten-2': !light && !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedPhoto && selectedPhoto.photo === photo,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(photo)
                                  }">
                                  {{usersDict[photo.split('_')[2]] || 'Anonim'}}
                                </div>
                                <div>
                                  <v-icon small color="warning" v-if="photo.includes('_badphoto')" title="Poza marcata de user ca fiind necorespunzatoare">mdi-alert</v-icon>
                                  <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                                  <a :href="serverURL + photo" download target="_blank" style="text-decoration: none">
                                    <v-icon small :color="selectedPhoto && selectedPhoto.photo === photo ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-download</v-icon>
                                  </a>
                                </div>
                              </div>
                            </template>
                          </template>
                        </div>
                      </template>
                    </template>

                    <template v-if="tab === 'pdfs'">
                      <template v-if="selectedItems.length">
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in selectedItems">
                            <div
                              :key="item._id + 'pdf' + index"
                              class="ma-1"
                              style="display: flex; flex-direction: column; align-items: center"
                              @click="_cbSelectDeletePdfProxy(item._id, pdf)"
                              v-for="(pdf, index) in item.pdfs">
                              <v-avatar
                                :color="toDelete.includes(pdf) ? 'error' : ''"
                                size="48"
                                class="ma-1"
                                :class="{
                                  'selected-photo': selectedPdf && selectedPdf.pdf === pdf && !deleteEnabled,
                                  'toDelete': isToDelete(pdf),
                                  'delete-enabled': deleteEnabled
                                }"
                                style="box-sizing: border-box">
                                <v-icon class="pa-1">
                                  mdi-file-pdf
                                </v-icon>
                              </v-avatar>
                              <span
                                :key="item._id + '_' + index + 'simbol'"
                                :class="{
                                  'blue-grey--text': light && !deleteEnabled,
                                  'grey--text text--lighten-2': !light && !deleteEnabled,
                                  'primary--text font-weight-bold': !deleteEnabled && selectedPdf && selectedPdf.pdf === pdf,
                                  'error--text': deleteEnabled,
                                  'font-weight-bold': isToDelete(pdf)
                                }">
                                {{item.id_scara}}_{{pdf.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                <a :href="serverURL + pdf" download target="_blank" style="text-decoration: none" title="Descarca pdf">
                                  <v-icon small :color="selectedPdf && selectedPdf.pdf === pdf ?  (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-download</v-icon>
                                </a>
                              </span>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in items">
                            <div
                              :key="item._id + 'photo' + index"
                              class="ma-1"
                              style="display: flex; flex-direction: column; align-items: center"
                              @click="_cbSelectDeletePdfProxy(item._id, pdf)"
                              v-for="(pdf, index) in item.pdfs">
                              <v-avatar
                                :color="toDelete.includes(pdf) ? 'error' : ''"
                                size="48"
                                class="ma-1"
                                :class="{
                                  'selected-photo': selectedPdf && selectedPdf.pdf === pdf && !deleteEnabled,
                                  'toDelete': isToDelete(pdf),
                                  'delete-enabled': deleteEnabled
                                }"
                                style="box-sizing: border-box">
                                <v-icon class="pa-1">
                                  mdi-file-pdf
                                </v-icon>
                              </v-avatar>
                              <span
                                :key="item._id + '_' + index + 'simbol'"
                                :class="{
                                  'blue-grey--text': light && !deleteEnabled,
                                  'grey--text text--lighten-2': !light && !deleteEnabled,
                                  'primary--text font-weight-bold': !deleteEnabled && selectedPdf && selectedPdf.pdf === pdf,
                                  'error--text': deleteEnabled,
                                  'font-weight-bold': isToDelete(pdf)
                                }">
                                {{item.id_scara}}_{{pdf.split('_')[1]}}_{{String(index + 1).padStart(3, '0')}}
                                <a :href="serverURL + pdf" download target="_blank" style="text-decoration: none">
                                  <v-icon small :color="selectedPdf && selectedPdf.pdf === pdf ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-download</v-icon>
                                </a>
                              </span>
                            </div>
                          </template>
                        </div>
                      </template>
                    </template>

                    <template v-if="tab === 'excels'">
                      <template v-if="selectedItems.length">
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in selectedItems">
                            <template v-for="(excel, index) in item.excels">
                              <div
                                :key="item._id + 'excel' + index"
                                class="ma-1"
                                style="display: flex; flex-direction: column; align-items: center; width: 64px"
                                @click="_cbSelectDeleteExcelProxy(item._id, excel)"
                                v-if="showIfBadExcel(excel)">
                                <v-avatar
                                  :color="toDelete.includes(excel) ? 'error' : ''"
                                  size="48"
                                  class="ma-1 excel-avatar"
                                  :class="{
                                    'selected-photo': selectedExcel && selectedExcel.excel === excel && !deleteEnabled,
                                    'toDelete': isToDelete(excel),
                                    'delete-enabled': deleteEnabled
                                  }"
                                  style="box-sizing: border-box">
                                  <v-icon large class="pa-1" color="green">
                                    mdi-file-excel
                                  </v-icon>
                                </v-avatar>
                                <div
                                  style="display: flex; justify-content: space-around; width: 100%; flex-direction: column; align-items: center"
                                  :key="item._id + '_' + index + 'simbol'"
                                  :class="{
                                    'blue-grey--text': light && !deleteEnabled,
                                    'grey--text text--lighten-2': !light && !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedExcel && selectedExcel.excel === excel,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(excel)
                                  }">
                                  <div class="filename-truncation" :title="excel.split('/')[3]">
                                    {{item.id_scara}}_{{excel.split('/')[3]}}
                                  </div>
                                  <div>
                                    <a :href="serverURL + excel" download target="_blank" style="text-decoration: none" title="Descarca excel">
                                      <v-icon small :color="selectedExcel && selectedExcel.excel === excel ?  (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-download</v-icon>
                                    </a>
                                    <v-icon small color="warning" v-if="excel.includes('_badexcel')" title="Excel marcat de user ca fiind necorespunzator">mdi-alert</v-icon>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          style="display: flex; flex-wrap: wrap">
                          <template v-for="item in items">
                            <template v-for="(excel, index) in item.excels">
                              <div
                                :key="item._id + 'excel' + index"
                                class="ma-1"
                                style="display: flex; flex-direction: column; align-items: center; width: 64px"
                                @click="_cbSelectDeleteExcelProxy(item._id, excel)"
                                v-if="showIfBadExcel(excel)">
                                <v-avatar
                                  :color="toDelete.includes(excel) ? 'error' : ''"
                                  size="48"
                                  class="ma-1 excel-avatar"
                                  :class="{
                                    'selected-photo': selectedExcel && selectedExcel.excel === excel && !deleteEnabled,
                                    'toDelete': isToDelete(excel),
                                    'delete-enabled': deleteEnabled
                                  }"
                                  style="box-sizing: border-box">
                                  <v-icon large class="pa-1" :color="isToDelete(excel) ? 'blue-grey lighten-5' : 'green'">
                                    mdi-file-excel
                                  </v-icon>
                                </v-avatar>
                                <div
                                  style="display: flex; justify-content: space-around; width: 100%; flex-direction: column; align-items: center"
                                  :key="item._id + '_' + index + 'simbol'"
                                  :class="{
                                    'blue-grey--text': light && !deleteEnabled,
                                    'grey--text text--lighten-2': !light && !deleteEnabled,
                                    'primary--text font-weight-bold': !deleteEnabled && selectedExcel && selectedExcel.excel === excel,
                                    'error--text': deleteEnabled,
                                    'font-weight-bold': isToDelete(excel)
                                  }">
                                  <div class="filename-truncation" :title="excel.split('/')[3]">
                                    {{item.id_scara}}_{{excel.split('/')[3]}}
                                  </div>
                                  <div>
                                    <v-icon small color="warning" v-if="excel.includes('_badexcel')" title="Excel marcat de user ca fiind necorespunzator">mdi-alert</v-icon>
                                    <a :href="serverURL + excel" download target="_blank" style="text-decoration: none">
                                      <v-icon small :color="selectedExcel && selectedExcel.excel === excel ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">mdi-download</v-icon>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </template>
                        </div>
                      </template>
                    </template>
                  </v-card-text>
                </v-card>
              </template>
              <template slot="paneR" v-if="showPreview">
                <v-card style="display: flex; flex-direction: column; height: 100%">
                  <v-card-title>
                    <div style="height: 28px; display: flex; align-items: center">
                      <span>Preview</span>
                      <template v-if="selectedPhoto && tab === 'photos'">
                        <v-btn icon small class="ma-0 ml-1" @click="zoom(1)" key="zoomin">
                          <v-icon small :color="light ? 'primary' : 'primary lighten-2'">mdi-plus</v-icon>
                        </v-btn>
                        <v-btn icon small class="ma-0 ml-1" @click="zoom(-1)" key="zoomout">
                          <v-icon small :color="light ? 'primary' : 'primary lighten-2'">mdi-minus</v-icon>
                        </v-btn>
                        <span class="caption" key="explanation"> (also ctrl + scroll)</span>
                        <v-btn icon small class="ma-0 ml-1" @click="savePhoto" key="save">
                          <v-icon small :color="light ? 'primary' : 'primary lighten-2'">mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                      <template v-if="tab === 'excels'">
                         <v-btn-toggle v-model="xlsxViewer" class="ml-2 elevation-0">
                          <v-btn flat :color="xlsxViewer === 0 ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">
                            <v-icon>mdi-microsoft</v-icon>
                          </v-btn>
                          <v-btn flat :color="xlsxViewer === 1 ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey lighten-2')">
                            <v-icon>mdi-google</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </template>
                    </div>
                  </v-card-title>
                  <v-card-text class="pa-0" style="overflow-x: auto; height: 100%; width: 100%">
                    <dir id="editor" style="height: 100%; overflow-x: auto" ref="editor" @wheel.ctrl.prevent="zoom($event.deltaY * -1)" v-if="tab === 'photos'"></dir>
                    <iframe :src="pdfFrameSrc" frameborder="0" width="100%" height="95%" v-if="tab === 'pdfs'"></iframe>
                    <embed :src="`https://docs.google.com/gview?url=${selectedExcel.excel}&embedded=true`" width="100%" height="100%" v-if="tab === 'excels' && xlsxViewer === 1">
                    <embed :src="`http://view.officeapps.live.com/op/view.aspx?src=${selectedExcel.excel}`" width="100%" height="100%" v-if="tab === 'excels' && xlsxViewer === 0">
                  </v-card-text>
                </v-card>
              </template>
            </split-pane>
          </template>
        </split-pane>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Incarcare XLSX cu simboluri</v-card-title>
        <v-card-text>
          <v-alert type="info" outline :value="true">
            Din fisierul xlsx se ignora primul rand (headere). Datele incep sa fie citite de pe randul 2.
            Se filtreaza toate randurile care nu au nimic pe prima coloana. Mai jos un exemplu de structura a fisierului xlsx.
            <v-img src="sample.xlsx.png" />
          </v-alert>
          <v-text-field
            v-model="label"
            label="Eticheta"
            hint="Eticheta aplicata simbolurilor ce urmeaza a fi incarcate"
            persistent-hint
            class="mt-5">
          </v-text-field>
          <form ref="form" class="mt-5">
            <input type="file" ref="fileinput" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeDialog" :disabled="uploading">Renunta</v-btn>
          <v-btn flat :color="light ? 'primary' : 'primary lighten-2'" @click="filesAdded" :loading="uploading" :disabled="uploading">Incarca</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="labelsDialog" max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Filtrare simboluri dupa eticheta</v-card-title>
        <v-card-text>
          <v-radio-group v-model="selectedLabel">
            <v-radio
              v-for="label in labels"
              :key="label.label"
              :label="`${label.label}`"
              :value="label.label"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat :color="light ? 'primary' : 'primary lighten-2'" @click="closeLabelsDialog">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="zonesDialog" max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Filtrare simboluri dupa zona</v-card-title>
        <v-card-text>
          <v-radio-group v-model="selectedZona">
            <v-radio
              v-for="zona in zones"
              :key="zona.zona"
              :label="zona.zona || 'Toate'"
              :value="zona.zona"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat :color="light ? 'primary' : 'primary lighten-2'" @click="closeZonesDialog">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addDialog" persistent scrollable :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Adaugare simbol</v-card-title>
        <v-card-text>
          <v-form ref="addForm" v-model="addFormValid" lazy-validation>
            <template v-for="field in fields">
              <template v-if="getType(field.value)">
                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'eticheta'"
                  :items="labelsText"
                  label="Eticheta"
                  :key="field.value"
                  :menu-props="{transition: false}"
                  v-model="newEntity[field.value]"
                  :rules="getRules(field.value)">
                </v-select>

                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'zona'"
                  :items="zonesText"
                  label="Zona"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :menu-props="{transition: false}"
                  :rules="getRules(field.value)">
                </v-select>

                <v-text-field
                  class="my-3"
                  v-if="getType(field.value) === 'text'"
                  :key="field.value"
                  :type="getType(field.value)"
                  v-model="newEntity[field.value]"
                  :label="field.label"
                  :hint="field.label.toLowerCase()"
                  persistent-hint
                  :rules="getRules(field.value)"
                  validate-on-blur
                  solo
                  flat>
                </v-text-field>

                <div style="width: 100%; height: 50vh" v-if="getType(field.value) === 'map'" :key="field.value">
                  <GmapMap
                    :center="mapCenter"
                    :zoom="13"
                    :style="{ width: '100%', height: '100%' }"
                    ref="map">

                    <GmapMarker
                      :position="mapCenter"
                      :draggable="true"
                      @dragend="_cbDragEnd" />

                  </GmapMap>
                </div>
              </template>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddDialog(0)" :ripple="false">Renunta</v-btn>
          <v-btn flat :color="light ? 'primary' : 'primary lighten-2'" @click="closeAddDialog(1)" :ripple="false">Salveaza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Bancul cu iepurasul care vrea sa faca clatite
import debounce from 'lodash.debounce'

import { createWriteStream } from 'streamsaver'

import slug from 'slug'

import splitPane from 'vue-splitpane'

import 'tui-image-editor/dist/tui-image-editor.css'
import 'tui-color-picker/dist/tui-color-picker.css'
import 'tui-image-editor/dist/svg/icon-a.svg'
import 'tui-image-editor/dist/svg/icon-b.svg'
import 'tui-image-editor/dist/svg/icon-c.svg'
import 'tui-image-editor/dist/svg/icon-d.svg'

import { GoogleMapsOverlay as DeckOverlay } from '@deck.gl/google-maps'
import { GeoJsonLayer } from '@deck.gl/layers'

const ImageEditor = require('tui-image-editor')

export default {
  name: 'dasboard',
  components: {
    'split-pane': splitPane
  },
  data: () => ({
    alphaForGl: 100,
    oldHorizontalPaneSize: 50,
    oldVerticalPaneSize: 50,
    cameraPic: '/img/camera-square-48.png',
    addFormValid: true,
    addDialog: false,
    newEntity: {
      id_scara: null,
      eticheta: null,
      zona: null,
      centru_geometric: {
        lat: 45.8643689,
        lng: 25.7724237
      }
    },
    mapCenter: {
      lat: 46.5398504,
      lng: 24.5579447
    },
    availableTipPoze: ['obiectiv', 'lift1', 'lift2', 'lift3', 'lift4', 'repozare'],
    tipPoze: ['obiectiv', 'lift1', 'lift2', 'lift3', 'lift4', 'repozare'],
    availableTipExcels: ['obiectiv'],
    tipExcels: ['obiectiv'],
    search: '',
    selectedItems: [],
    selectedPhoto: null,
    selectedPdf: null,
    selectedExcel: 'null',
    editor: null,
    zoomSizes: { width: 0, height: 0 },
    toDelete: [],
    toDeleteSymbols: [],
    deleteEnabled: false,
    deleteSymbolsEnabled: false,
    dialog: false,
    label: null,
    uploading: false,
    labelsDialog: false,
    zonesDialog: false,
    downloading: false,
    // tab: 'photos',
    pdfFrameTitle: '',
    pdfFrameSrc: '',
    data_inceput_menu: false,
    data_sfarsit_menu: false,

    fields: [ // eticheta, id_scara, adresa, observatii_scara, centru_geometric
      {
        value: 'eticheta',
        label: 'ETICHETA'
      },
      {
        value: 'zona',
        label: 'ZONA'
      },
      {
        value: 'id_scara',
        label: 'ID SCARA'
      },
      {
        value: 'centru_geometric',
        label: 'CENTRU GEOMETRIC'
      }
    ],

    xlsxViewer: 0
  }),
  filters: {
    dateFormat (date) {
      return date ? new Date(date).toLocaleString('ro-RO', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }) : 'nimic selectat'
    }
  },
  computed: {
    labelsText () {
      const etichete = this.$store.getters['entities/labels'].map(label => label.label)
      if (!etichete.length) etichete.push('Fara eticheta')
      return etichete
    },
    zonesText () {
      const zone = this.$store.getters['entities/zones'].map(zona => zona.zona)
      if (!zone.length) zone.push('Fara zona')
      return zone
    },
    visiblePhotosCount () {
      return this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.photos.length), 0)
    },
    visiblePdfsCount () {
      return this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.pdfs.length), 0)
    },
    visibleExcelsCount () {
      return this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.excels.length), 0)
    },
    serverURL () {
      return this.$store.getters.serverURL
    },
    searchTerm: {
      get () {
        return this.$store.getters['entities/search']
      },
      set (value) {
        this.search = value
        if (!value) {
          this._cbSearch()
        }
      }
    },
    loading () {
      return this.$store.getters.loading
    },
    items () {
      return this.$store.getters['entities/items']
    },
    page: {
      get () {
        return this.$store.getters['entities/page']
      },
      set (value) {
        this.$store.dispatch('entities/setPage', value)
      }
    },
    perPage: {
      get () {
        return this.$store.getters['entities/perPage']
      },
      set (value) {
        if (value <= 0) value = 10
        this.$store.dispatch('entities/setPerPage', value)
      }
    },
    total () {
      return this.$store.getters['entities/total']
    },
    totalPages () {
      return this.perPage ? Math.ceil(this.total / this.perPage) : 0
    },
    done () {
      return this.$store.getters['entities/done']
    },
    edited () {
      return this.$store.getters['entities/edited']
    },
    photos () {
      return this.$store.getters['entities/photos']
    },
    pdfs () {
      return this.$store.getters['entities/pdfs']
    },
    doneColor () {
      if (this.done === 1) return this.light ? 'primary' : 'primary lighten-2'
      if (this.done === -1) return 'error'
      return this.light ? 'blue-grey' : 'grey lighten-2'
    },
    // _2005Color () {
    //   if (this._2005 === 1) return this.light ? 'primary' : 'primary lighten-2'
    //   if (this._2005 === -1) return 'error'
    //   return this.light ? 'blue-grey' : 'grey lighten-2'
    // },
    editedColor () {
      if (this.edited === 1) return this.light ? 'primary' : 'primary lighten-2'
      if (this.edited === -1) return 'error'
      return this.light ? 'blue-grey' : 'grey lighten-2'
    },
    photosColor () {
      if (this.photos === 1) return this.light ? 'primary' : 'primary lighten-2'
      if (this.photos === -1) return 'error'
      return this.light ? 'blue-grey' : 'grey lighten-2'
    },
    pdfsColor () {
      if (this.pdfs === 1) return this.light ? 'primary' : 'primary lighten-2'
      if (this.pdfs === -1) return 'error'
      return this.light ? 'blue-grey' : 'grey lighten-2'
    },
    info () {
      return this.$store.getters.info
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    selectedLabel: {
      get () {
        return this.$store.getters['entities/selectedLabel']
      },
      set (value) {
        // console.log('set selected label')
        this.$store.commit('entities/setSelectedLabel', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    selectedZona: {
      get () {
        return this.$store.getters['entities/selectedZona']
      },
      set (value) {
        // console.log('set selected zona')

        this.$store.commit('entities/setSelectedZona', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    token () {
      return this.$store.getters.token
    },

    dataInceput: {
      get () {
        return this.$store.getters['entities/dataInceput']
      },
      set (value) {
        // console.log('set data inceput')
        this.$store.commit('entities/setDataInceput', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    dataSfarsit: {
      get () {
        return this.$store.getters['entities/dataSfarsit']
      },
      set (value) {
        // console.log('set data sfarsit')

        this.$store.commit('entities/setDataSfarsit', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },

    // _2005 () {
    //   return this.$store.getters['entities/_2005']
    // },

    users () {
      return this.$store.getters['entities/dbusernames']
    },
    usersDict () {
      return this.$store.getters['entities/usersDict']
    },
    selectedUsernames: {
      get () {
        return this.$store.getters['entities/selectedUsernames']
      },
      set (value) {
        this.$store.commit('entities/setSelectedUsernames', value)
      }
    },
    user () {
      return this.$store.getters.user
    },

    repozare () {
      return this.$store.getters['entities/repozare']
    },
    repozareColor () {
      if (this.repozare === 1) return 'error'
      if (this.repozare === -1) return this.light ? 'primary' : 'primary lighten-2'
      return this.light ? 'blue-grey' : 'grey lighten-2'
    },
    excels () {
      return this.$store.getters['entities/excels']
    },
    excelsColor () {
      if (this.excels === 1) return this.light ? 'primary' : 'primary lighten-2'
      if (this.excels === -1) return 'error'
      return this.light ? 'blue-grey' : 'grey lighten-2'
    },

    tab () {
      return this.$store.getters.tab
    },
    paneVertical () {
      return this.$store.getters.paneVertical
    },
    paneHorizontal () {
      return this.$store.getters.paneHorizontal
    },
    showGallery () {
      return this.$store.getters.showGallery
    },
    showPreview () {
      return this.$store.getters.showPreview
    },
    light () {
      return this.$store.getters.light
    },

    geoJsonItems () {
      const json = this.items.map(item => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [item.centru_geometric.lng, item.centru_geometric.lat]
          },
          properties: {
            done: item.done,
            user: item.user,
            zona: item.zona,
            repozare: item.repozare,
            _id: item._id
          }
        }
      })

      return json
    }
  },
  watch: {
    tab: {
      immediate: true,
      handler: function (val) {
        if (val === 'photos' && this.showGallery && this.showPreview) {
          this.$nextTick(() => {
            this.initializeEditor()
          })
        }
      }
    },
    showGallery: {
      immediate: true,
      handler: function (val) {
        if (this.tab === 'photos' && val && this.showPreview) {
          this.$nextTick(() => {
            this.initializeEditor()
          })
        }
      }
    },
    showPreview: {
      immediate: true,
      handler: function (val) {
        if (this.tab === 'photos' && this.showGallery && val) {
          this.$nextTick(() => {
            this.initializeEditor()
          })
        }
      }
    }
  },
  methods: {
    getRepozareDate (photo) {
      const uploadDate = new Date(+photo.split('_')[3]).toLocaleString('ro-RO')
      const repozareDate = photo.includes('_repozare_') ? new Date(+photo.substring(photo.indexOf('_repozare_') + 10, photo.lastIndexOf('.'))).toLocaleString('ro-RO') : 'Nope'

      return `Upload: ${uploadDate} - Repozare: ${repozareDate}`
    },
    getCircleFillColor (marker) {
      return [255, 255, 255, 255]
    },
    getCircleLineColor (marker) {
      return [0, 0, 0, 255]
    },
    _cbAddEntity () {
      this.addDialog = true
      this.$refs.map[0].$mapPromise.then(() => {
        window.overlay = new DeckOverlay({
          layers: [
            new GeoJsonLayer({
              id: 'markers',
              data: this.geoJsonItems,
              pointType: 'circle',
              // Styles

              pointRadiusUnits: 'meters',
              getPointRadius: 2,
              pointRadiusScale: 1,
              pointRadiusMinPixels: 8,
              pointRadiusMaxPixels: 12,
              pointAntialiasing: true,
              pointBillboard: false,

              filled: true,
              getFillColor: f => this.getCircleFillColor(f.properties),
              getLineColor: f => this.getCircleLineColor(f.properties),
              getLineWidth: 20,
              lineWidthMinPixels: 1,
              lineWidthMaxPixels: 2,
              // Interactive props
              pickable: false,
              autoHighlight: true
            })
          ]
        })

        window.overlay.setMap(this.$refs.map[0].$mapObject)
      })
    },
    downloadRaportDuplicat () {
      let filtersQuery = 'filters=nope'

      const filters = {
        done: this.done,
        edited: this.edited,
        photos: this.photos,
        pdfs: this.pdfs,
        page: this.page,
        perPage: this.perPage,
        search: this.searchTerm,
        datainceput: this.dataInceput,
        datasfarsit: this.dataSfarsit
      }
      filtersQuery = new URLSearchParams(filters).toString()

      this.downloading = true
      fetch(`${this.serverURL}/raport3?label=${this.selectedLabel}&zona=${this.selectedZona}&${filtersQuery}`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = 'Poze-TgMures_Poze_Identice.xlsx'
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)
          alert('Whoops! Something went wrong...')
        })
    },
    downloadRaport2 () {
      this.downloading = true
      fetch(`${this.serverURL}/raport2`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = 'Poze-TgMures_Poze_User_size.xlsx'
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)
          alert('Whoops! Something went wrong...')
        })
    },
    downloadXLSX (filters) {
      let filtersQuery = 'filters=nope'
      if (filters) {
        const paginatie = window.confirm('Doresti sa descraci doar prima pagina?')

        const filters = {
          done: this.done,
          edited: this.edited,
          photos: this.photos,
          pdfs: this.pdfs,
          page: this.page,
          perPage: this.perPage,
          search: this.searchTerm,
          datainceput: this.dataInceput,
          datasfarsit: this.dataSfarsit,
          paginatie
        }

        filtersQuery = new URLSearchParams(filters).toString()

        console.log(filtersQuery)
      }

      const users = this.selectedUsernames.join(',')

      this.downloading = true
      fetch(`${this.serverURL}/raport?users=${users}&label=${this.selectedLabel}&zona=${this.selectedZona}&${filtersQuery}`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = `Poze-TgMures_${this.selectedLabel ? slug(this.selectedLabel) : 'Toate'}_${filters ? 'Vizibile' : 'Toate'}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.xlsx`
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)
          alert('Whoops! Something went wrong...')
        })
    },
    resetLabel () {
      this.selectedLabel = null
    },
    resetZona () {
      this.selectedZona = null
    },
    openLabelsDialog () {
      this.labelsDialog = true
    },
    closeLabelsDialog () {
      this.labelsDialog = false
    },
    openZonesDialog () {
      this.zonesDialog = true
    },
    closeZonesDialog () {
      this.zonesDialog = false
    },
    closeDialog () {
      this.dialog = false
      this.label = null
      this.$refs.form.reset()
    },
    refreshInfo () {
      this.$store.dispatch('getInfo')
    },
    isToDelete (file) {
      return this.toDelete.includes(file)
    },
    _cbConfirmDeleteSymbolsBatch () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.items.length} simboluri si pozele aferente! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          const ids = this.items.map(item => item._id)
          this.$store.dispatch('entities/deleteEntities', ids)
        })
        .catch(() => {})
    },
    _cbConfirmDeleteSymbols () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.toDeleteSymbols.length} simboluri si pozele aferente! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          this.selectedItems = this.selectedItems.filter(item => !this.toDeleteSymbols.includes(item._id))
          this.$store.dispatch('entities/deleteEntities', this.toDeleteSymbols)
          this.toDeleteSymbols = []
        })
        .catch(() => {})
    },
    _cbSelectDeleteSymbolProxy (item) {
      if (this.deleteSymbolsEnabled) {
        const index = this.toDeleteSymbols.findIndex(simbol => simbol === item._id)
        if (index > -1) this.toDeleteSymbols.splice(index, 1)
        else this.toDeleteSymbols.push(item._id)
      } else {
        this.setSelectedItem(item)
      }
    },
    _cbSelectDeletePhotoProxy (itemId, photo) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === photo)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(photo)
      } else {
        this.setSelectedPhoto(itemId, photo)
      }
    },
    _cbToggleDeleteMode (type) {
      if (type === 'photo') {
        this.deleteEnabled = !this.deleteEnabled
        this.toDelete = []
      } else {
        this.deleteSymbolsEnabled = !this.deleteSymbolsEnabled
        this.toDeleteSymbols = []
      }
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.toDelete.length} ${this.tab}! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          switch (this.tab) {
            case 'photos': {
              const photos = this.toDelete.filter(item => item.startsWith('/photos/'))
              this.$store.dispatch('entities/deletePhotos', { entity: this.deleteEntity, photos })
              this.selectedItems.forEach(item => {
                item.photos = item.photos.filter(photo => !this.toDelete.includes(photo))
              })
              break
            }
            case 'pdfs': {
              const pdfs = this.toDelete.filter(item => item.startsWith('/pdfs/'))
              this.$store.dispatch('entities/deletePdfs', { entity: this.deleteEntity, pdfs })
              this.selectedItems.forEach(item => {
                item.pdfs = item.pdfs.filter(pdf => !this.toDelete.includes(pdf))
              })
              break
            }
            case 'excels': {
              const excels = this.toDelete.filter(item => item.startsWith('/excels/'))
              this.$store.dispatch('entities/deleteExcels', { entity: this.deleteEntity, excels })
              this.selectedItems.forEach(item => {
                item.excels = item.excels.filter(excel => !this.toDelete.includes(excel))
              })
              break
            }
          }

          this.toDelete = []
        })
        .catch(() => {})
    },
    _cbSearch () {
      this.$nextTick(() => {
        this.$store.dispatch('entities/search', this.search)
      })
    },
    isSelectedItem (item) {
      return !!this.selectedItems.find(sItem => sItem._id === item._id)
    },
    toggleDone () {
      this.$store.dispatch('entities/toggleDone')
    },
    toggleEdited () {
      this.$store.dispatch('entities/toggleEdited')
    },
    togglePhotos () {
      this.$store.dispatch('entities/togglePhotos')
    },
    toggleRepozare () {
      this.$store.dispatch('entities/toggleRepozare')
    },
    // toggle2005 () {
    //   this.$store.dispatch('entities/toggle2005')
    // },
    togglePdfs () {
      this.$store.dispatch('entities/togglePdfs')
    },
    toggleFilter (filter) {
      this.$store.dispatch('entities/toggleFilter', filter)
    },
    getSrc (marker) {
      if (marker.repozare === 'Da') return '/svg/repozare.png'
      if (marker.addedBy) {
        if (marker.done) return '/svg/done_people.png'
        return marker.user ? '/svg/edited_people.png' : '/svg/unedited_people.png'
      } else {
        if (marker.done) return '/svg/done.png'
        return marker.user ? '/svg/edited.png' : '/svg/unedited.png'
      }
    },
    setSelectedItem (item) {
      if (this.isSelectedItem(item)) {
        this.selectedItems = this.selectedItems.filter(sItem => sItem._id !== item._id)
      } else {
        this.selectedItems.push(item)
        this.selectedItems = this.selectedItems.sort((a, b) => a.id_scara.localeCompare(b.id_scara))
      }
    },
    setSelectedPhoto (itemId, photo) {
      this.selectedPhoto = {
        id: itemId,
        photo
      }

      if (this.showPreview) {
        const canvasSize = this.editor.getCanvasSize()
        const width = this.$refs.editor.scrollWidth
        const height = this.$refs.editor.scrollHeight

        this.editor.loadImageFromURL(this.serverURL + photo, photo).then(result => {
          const { newWidth, newHeight } = result
          const ratio = newWidth / newHeight

          this.editor.ui.resizeEditor({
            imageSize: result,
            uiSize: { width, height }
          })

          if (this.zoomSizes.width) {
            canvasSize.width = this.zoomSizes.width
            canvasSize.height = width / ratio
          } else {
            canvasSize.width = width
            canvasSize.height = width / ratio
          }
          this.editor.resizeCanvasDimension(canvasSize)

          this.zoomSizes = canvasSize
          this.editor.clearRedoStack()
          this.editor.clearUndoStack()
          // w = r * h
          // h = w / r
        })
      }
    },
    clearSelected () {
      this.selectedItems = []
    },
    zoom (dir) {
      const canvasSize = this.zoomSizes
      const ratio = canvasSize.width / canvasSize.height
      const width = canvasSize.width * (dir > 0 ? 1.1 : 0.9)
      if (width > 0) {
        const height = width / ratio
        this.editor.resizeCanvasDimension({ width, height })
        this.zoomSizes = { width, height }
      }
    },
    savePhoto () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Operatie ireversibila. Confirmi operatia?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          const options = {
            format: 'jpeg',
            quality: 1
          }
          const newImage = this.editor.toDataURL(options)
          // console.log(newImage)
          this.$store.dispatch('entities/saveEditedPhoto', { ...this.selectedPhoto, newImage, parent: this.selectedPhoto.photo.split('_')[1] })
            .then(response => {
              this.editor.clearRedoStack()
              this.editor.clearUndoStack()
              const index = this.selectedItems.findIndex(item => item._id === response._id)
              if (index > -1) this.selectedItems.splice(index, 1, response)

              this.selectedPhoto = null
              this.editor.loadImageFromURL(this.serverURL + '/img/placeholder.png', 'photo')

              // console.log('save photo')

              this.$store.dispatch('entities/fetchEntities')
            })
            .catch(err => {
              console.log(err)
              alert('Whoopsie! Ceva eroare la salvarea fisierului... (vezi in consola)')
            })
        })
        .catch(() => {})
    },
    async download (type) {
      let badPhotos = false
      try {
        await this.$dialog
          .confirm({
            title: 'Optiune download',
            body: 'Vrei sa descarci si pozele marcate ca fiind necorespunzatoare?'
          }, {
            okText: 'DA',
            cancelText: 'Nu',
            animation: 'zoom'
          })
        badPhotos = true
      } catch (e) {
        badPhotos = false
      }
      const data = this.selectedItems.length ? this.selectedItems.map(item => item._id) : this.items.map(item => item._id)
      const fileStream = createWriteStream(`Poze-TgMures_${slug(this.selectedLabel || 'Toate')}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.zip`)
      this.$store.dispatch('dowloadZip', { type, photos: data, badPhotos })
        .then(res => {
          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream)
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => done
            // close the stream so we stop writing
            ? writer.close()
            // Write one chunk, then get the next one
            : writer.write(value).then(pump)
          )

          // Start the reader
          pump().then(() =>
            console.log('Closed the stream, Done writing')
          )
        })
    },
    downloadPdfs (mode) {
      const data = this.selectedItems.length ? this.selectedItems.map(item => item._id) : this.items.map(item => item._id)
      const fileStream = createWriteStream(`Poze-TgMures_${slug(this.selectedLabel || 'Toate')}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.zip`)
      this.$store.dispatch('dowloadPdfsZip', { mode, pdfs: data })
        .then(res => {
          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream)
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => done
            // close the stream so we stop writing
            ? writer.close()
            // Write one chunk, then get the next one
            : writer.write(value).then(pump)
          )

          // Start the reader
          pump().then(() =>
            console.log('Closed the stream, Done writing')
          )
        })
    },
    downloadExcels (mode) {
      const data = this.selectedItems.length ? this.selectedItems.map(item => item._id) : this.items.map(item => item._id)
      const fileStream = createWriteStream(`Poze-TgMures_${slug(this.selectedLabel || 'Toate')}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.zip`)
      this.$store.dispatch('dowloadExcelsZip', { mode, excels: data })
        .then(res => {
          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream)
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => done
            // close the stream so we stop writing
            ? writer.close()
            // Write one chunk, then get the next one
            : writer.write(value).then(pump)
          )

          // Start the reader
          pump().then(() =>
            console.log('Closed the stream, Done writing')
          )
        })
    },
    uplaodXLSX () {
      this.dialog = true
      // this.$refs.fileinput.click()
    },
    filesAdded (e) {
      if (!this.$refs.fileinput.files.length) return
      // this.$store.commit('setLoading', true)

      this.uploading = true

      let file = this.$refs.fileinput.files[0]

      try {
        let fileReader = new FileReader()
        /* eslint-disable handle-callback-err */
        fileReader.onload = event => {
          this.$store.dispatch('entities/uploadXLSX', {
            buffer: event.target.result,
            label: this.label
          }).then((res) => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
          }).catch(error => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
            alert('Whoops! Whoopsie! Ceva nu a functionat...')
          })
        }
        fileReader.readAsDataURL(file)
        // console.log(photos)
      } catch (err) {
        // this.$store.commit('setLoading', false)
        this.uploading = false
        this.$refs.form.reset()
        this.label = null
        this.dialog = false
        alert('Dispozitivul d-voastra nu suporta aceasta functie.')
      }
    },
    toggleTab () {
      const tab = this.tab === 'photos' ? 'excels' : 'photos'
      this.toDelete = []

      this.$store.commit('setDashboardTab', tab)
      // if (tab === 'photos') {
      //   this.$nextTick(() => {
      //     this.initializeEditor()
      //   })
      // }
    },

    _cbSelectDeletePdfProxy (itemId, pdf) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === pdf)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(pdf)
      } else {
        this.setSelectedPdf(itemId, pdf)
      }
    },
    setSelectedPdf (itemId, pdf) {
      this.selectedPdf = {
        id: itemId,
        pdf
      }

      this.pdfFrameSrc = this.serverURL + pdf + '?buster=' + new Date().getTime()
      this.pdfFrameTitle = pdf.replace('/pdfs/', '')
    },

    _cbSelectDeleteExcelProxy (itemId, excel) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === excel)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(excel)
      } else {
        this.setSelectedExcel(itemId, excel)
      }
    },
    setSelectedExcel (itemId, excel) {
      this.selectedExcel = {
        id: itemId,
        excel // : 'https://static.anaf.ro/rapfxb/LOT244/20200131_FXB-EXB-901_TREZ701_4505359_4505359_02_18643433.xlsx?id=' + new Date().getTime()
      }

      // this.pdfFrameSrc = this.serverURL + pdf + '?buster=' + new Date().getTime()
      // this.pdfFrameTitle = pdf.replace('/pdfs/', '')
    },

    resetData (which) {
      this[`data${which}`] = null
    },

    showIfBadPhoto (photo) {
      if (this.tipPoze.includes('bad photos')) {
        return photo.includes('badphoto')
      } else {
        return !photo.includes('badphoto')
      }
    },
    showIfBadExcel (excel) {
      if (this.tipExcels.includes('bad excels')) {
        return excel.includes('badexcel')
      } else {
        return !excel.includes('badexcel')
      }
    },

    filterByUsername () {
      this.$store.dispatch('entities/filterByUsername', this.selectedUsernames)
    },

    getRules (fieldValue) {
      switch (fieldValue) {
        case 'id_scara':
        case 'eticheta': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'zona': return [val => val === null ? 'Camp obligatoriu' : true]
        default: return []
      }
    },
    getType (fieldValue) {
      switch (fieldValue) {
        case 'eticheta': return 'select'
        case 'zona': return 'select'
        case 'id_scara': return 'text'
        case 'centru_geometric': return 'map'
        default: return false
      }
    },
    _cbDragEnd: debounce(function ($event) {
      const pos = { lat: $event.latLng.lat(), lng: $event.latLng.lng() }
      this.$set(this.newEntity, 'centru_geometric', pos)
      this.$forceUpdate()
    }, 1000),
    closeAddDialog (mode) {
      if (mode) {
        if (!this.$refs.addForm.validate()) return
        this.addDialog = false
        this.$refs.addForm.resetValidation()

        const obj2save = {}

        Object.keys(this.newEntity).forEach(key => {
          switch (this.getType(key)) {
            case 'map': obj2save[key] = this.newEntity[key] ? { ...this.newEntity[key] } : null; break
            case 'number': obj2save[key] = !isNaN(this.newEntity[key]) ? Number(this.newEntity[key]) : null; break
            default: obj2save[key] = this.newEntity[key] === null ? null : String(this.newEntity[key])
          }

          this.newEntity[key] = null
          // this.newEntity.id_scara = null
        })

        this.newEntity.centru_geometric = { ...this.mapCenter }
        // this.newEntity.regim_inaltime = 'P'

        if (JSON.stringify(this.newEntity) !== JSON.stringify(obj2save)) {
          obj2save.done = false
          if (!this.user.admin) {
            obj2save.user = this.user.username
            obj2save.addedBy = this.user.username
          }

          this.$store.state.services.entities.create(obj2save)
        }
      } else {
        this.addDialog = false
        this.$refs.addForm.resetValidation()
        this.newEntity = {
          eticheta: null,
          zona: null,
          id_scara: null,
          centru_geometric: { ...this.mapCenter }
        }
      }

      if (window.overlay) {
        window.overlay.finalize()
        window.overlay = null
      }
    },
    toggleExcels () {
      this.$store.dispatch('entities/toggleExcels')
    },

    paneResize: debounce(function ($event, direction) {
      this.$store.commit('setDashboardSplitPane', { val: $event, dir: direction })
    }, 1000),

    toggleGallery () {
      if (this.showGallery) {
        this.oldHorizontalPaneSize = this.paneHorizontal < 100 ? this.paneHorizontal : 50
        this.paneResize(100, 'horizontal')
      } else {
        this.paneResize(this.oldHorizontalPaneSize, 'horizontal')
      }

      // if (!this.showGallery && this.tab === 'photos') {
      //   this.$nextTick(() => {
      //     this.initializeEditor()
      //   })
      // }

      this.$store.commit('setGalleryVisibility', !this.showGallery)
    },
    togglePreview () {
      if (this.showPreview) {
        this.oldVerticalPaneSize = this.paneVertical < 100 ? this.paneVertical : 50
        this.paneResize(100, 'vertical')
      } else {
        this.paneResize(this.oldVerticalPaneSize, 'vertical')
      }

      // if (!this.showPreview && this.tab === 'photos') {
      //   this.$nextTick(() => {
      //     this.initializeEditor()
      //   })
      // }

      this.$store.commit('setPreviewVisibility', !this.showPreview)
    },

    initializeEditor: debounce(function () {
      console.log('initializing editor')

      if (this.searchTerm) {
        this.search = this.searchTerm
      }

      this.editor = new ImageEditor(document.querySelector('#editor'), {
        includeUI: {
          loadImage: {
            // path: this.serverURL + photo,
            path: this.serverURL + '/img/placeholder.png',
            // path: 'https://www.grouphealth.ca/wp-content/uploads/2018/05/placeholder-image-300x225.png',
            name: 'photo'
          },
          // initMenu: 'filter',
          menuBarPosition: 'bottom'
        },
        cssMaxWidth: 700,
        cssMaxHeight: 500,
        selectionStyle: {
          cornerSize: 20,
          rotatingPointOffset: 70
        }
      })
    }, 500)
  },
  mounted () {
    // if (this.tab === 'photos' && this.showGallery && this.showPreview) {
    //   this.initializeEditor()
    // }
    this.$store.dispatch('entities/fetchUsernames')
  }
}
</script>

<style>
.components-container {
  position: relative;
  height: 100%;
}

.photo, .excel-avatar {
  box-sizing: border-box;
  border: 2px dashed #CFD8DC;
  border-radius: 100%;
  height: 48px;
  width: 48px;
  cursor: pointer;
}

.photo.delete-enabled, .excel-avatar.delete-enabled {
  opacity: .55;
  border-color: var(--v-error-base);
  border-style: dashed;
}

.photo.toDelete, .excel-avatar.toDelete {
  opacity: 1;
  border-style: solid;
  background-color: var(--v-error-base);
}

.selected-photo {
  border-style: solid;
  border-color: var(--v-primary-base);
  font-weight: bold;
}

.selected-photo-simbol {
  color: var(--v-primary-base);
  font-weight: bold;
}

.tui-image-editor-header {
  /* visibility: hidden; */
  display: none;
}

.symbol {
  opacity: .55;
  border: 2px dashed #CFD8DC;
  border-radius: 100%;
  padding: 26px;
}

.opacity1 {
  opacity: 1 !important;
}

.symbol.selected-symbol{
  border-color: var(--v-primary-base);
  border-style: solid;
}
.symbol.delete-enabled{
  border-color: var(--v-error-base);
  border-style: dashed;
}
.symbol.toDelete{
  border-style: solid;
}
</style>
